import React from 'react';
import { Textbox } from "components/Textbox/Textbox";
import { SelectBox } from "components/Select/Select";

interface MessageSettingsProps {
    object: any;
}

export const MessageSettings: React.FC<MessageSettingsProps> = ({ object }) => {
    return (
        <>
            <div>
                <Textbox
                    textboxType="text"
                    textboxName="message"
                    labelText="message"
                    defaultValue={!object?.message ? null : object?.message}
                    required
                />
            </div>
            <div>
                <SelectBox
                    selectType="select"
                    name="messageType"
                    lable="messageType"
                    value={object?.labelStyle}
                    val={["info", "instruction", "error", "alert"]}
                    options={["info", "instruction", "error", "alert"]}
                />
            </div>
        </>
    );
}; 